import { render, staticRenderFns } from "./AudioWaveformView.vue?vue&type=template&id=11d2dbae&"
import script from "./AudioWaveformView.vue?vue&type=script&lang=js&"
export * from "./AudioWaveformView.vue?vue&type=script&lang=js&"
import style0 from "./AudioWaveformView.vue?vue&type=style&index=0&id=11d2dbae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports